.uui-tree-select-item-container {
    display: flex;
    justify-content: space-between;
}

.uui-tree-select-child-container {
    display: flex;
}

.uui-tree-select-item-count {
    margin-top: 4px;
    margin-bottom: 0;
}

.uui-tree-select-child-item-container {
    margin-bottom: 10px;
}



.uui-tree-select-indent-container {
    margin-left: 30px;
}

.uui-button-toggle-isexpanded {
    transform: rotate(90deg);
}

.uui-button-toggle-expand {
    transition: transform 300ms;
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    margin-right: 10px;
    margin-top: 3px;
    font-size: var(--uui-default-font-size);
  }